import { Ripple } from "../Ripple"
import type { FileInputProps } from "./FileInputProps"
import cx from "classix"

import cbStyle from "./index.module.css"
import btnStyle from "../Button/index.module.css"
import { getRippleColorFromColorStyle } from "../../utils"
import { use } from "react"
import { FieldsetContext } from "~/shared/ui/kit/components/Fieldset"

export type { FileInputProps }

/** Обёртка вокруг `<input type='file'>`. */
export const FileInput = function FileInput({
																		 label,
																		 colorStyle = "primary",
																		 transparent = false,
																		 fillable = false,
																		 borderless = false,
																		 disabled = false,
																		 onChange,
																		 multiple = false,
																		 accept,
																		 style,
																		 className
																	 }: FileInputProps) {

	const fs = use(FieldsetContext)
	const isDisabled = disabled || fs.disabled

	// <label> нужен для создания связи со скрытым <input>, чтобы при нажатии на него открывалось окно выбора файла
	return (
		<div style={style} className={cx(cbStyle.fileInput, className)}>
			<label className={cx(
				btnStyle.button,
				isDisabled && btnStyle.disabled,
				borderless && btnStyle.borderless,
				transparent && btnStyle.transparent,
				fillable && btnStyle.fillable,
				`cs-${colorStyle}`,
				className)}>
				<Ripple color={getRippleColorFromColorStyle(colorStyle)} />
				<span>{label}</span>
				<input onChange={e => onChange?.(e.target.files)}
					   multiple={multiple}
					   type="file"
					   accept={accept} />
			</label>
		</div>
	)
}

FileInput.displayName = "FileInput"